import React, { useReducer, useState, useEffect } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import FlightIcon from "@material-ui/icons/FlightTakeoffOutlined";
import authReducer, { INITIAL_STATE } from "../../reducers/auth_reducer";
import AuthActions from "../../actions/auth_actions";
import TopNavigationBar from "../../components/tab_component";
import PageNotFound from "../../components/universal/page_not_found";
import Reports from "./Reports";
import Admin from "./Admin";

export default function NewReports(props) {
  const topNavMenu = [
    {
      label: (
        <div>
          <FlightIcon className="nav_icon" />
          &nbsp;Reports
        </div>
      ),
      name: "Reports",
      redirect: "/org/reports/sub_reports/favourites",
      section: "/reports/sub_reports",
    },
    {
      label: (
        <div>
          <FlightIcon className="nav_icon" />
          &nbsp;Admin
        </div>
      ),
      name: "Admin",
      redirect: "/org/reports/admin/setup",
      section: "/reports/admin",
    },
  ];

  const Section = "Reports";
  const [authState, dispatch] = useReducer(authReducer, INITIAL_STATE);
  const [categories, setCategories] = useState([]);
  const [topMenus, setTopMenus] = useState([]);

  useEffect(() => {
    AuthActions.setUserData(dispatch, sessionStorage.getItem("authState"));
  }, []);

  useEffect(() => {
    setCategories(
      authState?.authState?.categories?.find(
        (category) => category.name === Section
      ).sub_categories
    );
  }, [authState?.authState?.categories]);

  useEffect(() => {
    if (categories) {
      setTopMenus(
        topNavMenu.filter((section) => {
          return categories?.some((category) => {
            return category.name === section.name;
          });
        })
      );
    }
  }, [categories?.length]);

  const [permission, setPermission] = useState([]);
  useEffect(() => {
    setPermission(
      categories?.map((category) => {
        return authState.authState.permissions.find(
          (permission) => permission.source_id === category.id
        );
      })
    );
  }, [categories]);

  useEffect(() => {
    if (permission) {
      setTopMenus(
        topNavMenu.filter((section) => {
          return permission
            .filter((permission) => {
              return permission.read || permission.write;
            })
            ?.some((category) => {
              //
              return category.source_type === section.name;
            });
        })
      );
    }
  }, [permission]);

  return (
    <div>
      {!!topMenus.length && (
        <>
          <TopNavigationBar {...props} tabProperties={topMenus} />
          <Switch>
            <Route
              path={"/org/reports/sub_reports"}
              component={(props) => (
                <Reports
                  {...props}
                  permission={permission?.find(
                    (per) => per?.source_type === "Reports"
                  )}
                />
              )}
            />
            <Route
              path={"/org/reports/admin"}
              component={(props) => (
                <Admin
                  {...props}
                  permission={permission?.find(
                    (per) => per?.source_type === "Admin"
                  )}
                />
              )}
            />

            <Route component={PageNotFound} />
          </Switch>
        </>
      )}
    </div>
  );
}
